import React from "react";
// import { Link } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import "./footer.css";
import logo from "../Assets/Vector.svg";
import Facebook from "../Assets/facebook.svg";
import Twitter from "../Assets/twitter.svg";
import Instagram from "../Assets/Instagram.svg";
import LinkedIn from "../Assets/LinkedIn.svg";
import whatsap from "../Assets/whatsap.svg";
import youtube from "../Assets/youtube.svg";

const Footer = () => {
  return (
    <div className="footer">
      <div className="containe">
        <div className="footer-rapper">
          <div className="footer-col">
            <div className="footer-logo">
              <img src={logo} alt="" />
              <p>OVest</p>
            </div>
            <p className="">
              OVest is here to help you achieve security, build wealth and
              realise your financial dreams. You can save, invest and earn more
              money.
            </p>
            <div className="socials">
              <a href="https://www.facebook.com/OVestOfficial/" target="blank">
                <img src={Facebook} alt="" />
              </a>
              <a href="https://twitter.com/OVestOfficial" target="blank">
                <img src={Twitter} alt="" />
              </a>

              <a href="https://www.instagram.com/OVestOfficial/" target="blank">
                <img src={Instagram} alt="" />
              </a>
              <a
                href="https://ng.linkedin.com/company/ovestofficial"
                target="blank"
              >
                <img src={LinkedIn} alt="" />
              </a>
              <a href="https://wa.me/2348060831576" target="blank">
                <img src={whatsap} alt="" />
              </a>

              <a
                href="https://www.youtube.com/channel/UCrDt222cOF5xptbFk1Uzb-Q"
                target="_blank"
              >
                <img src={youtube} alt="" />
              </a>
            </div>
          </div>
          <div className="footer-col">
            <h2>Company</h2>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/agent">Become an Agents</Link>
              </li>
              <Link to="/privacy">
                <li>Privacy</li>
              </Link>
              <Link to="/terms">
                <li>Terms & MoU</li>
              </Link>
            </ul>
          </div>
          <div className="footer-col">
            <h2>Quick Links</h2>
            <ul>
              <li>
                <Link to="/faqs">FAQ</Link>
              </li>
              <li>
                <Link to="/#testimonials">
                  <li>Testimonials</li>
                </Link>
              </li>

              <Link to="/investment/#ovest-investment-plan">
                <li>Investment Plans</li>
              </Link>
              <Link to="/security">
                <li>Security</li>
              </Link>
              <a
                href="https://myovest.com/blog/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <li>Blog</li>
              </a>
            </ul>
          </div>
          <div className="footer-col">
            <h2>Contact</h2>
            <ul>
              {" "}
              <li class="">
                <a href="mailto:hello@myovest.com">hello@myovest.com</a>
              </li>
              <li className="">
                <a href="tel:+2348060831576">+2348060831576</a>
              </li>
              <p>
                1. Majaro Street, Ajibade Bus Stop, Coca-diva Area, Mokola,
                Ibadan, Nigeria.
              </p>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <hr style={{ marginTop: "30px" }} />
          <p>
            OVest is an entity of OSource Vestment Ltd. A company duly
            registered with CAC with RC number 1776455. myovest.com is managed by a
            team of experienced and competent professionals in the finance,
            investment and money market across the world to ensure optimum
            return.
          </p>
          <p className="footer-p2">
            Our drive is to consistently be the platform that enrich financially
            and consistently deliver quality returns to our OVestors in the bid
            to earn total financial liberation.{" "}
          </p>
        </div>
        <div className="mt-2 footer-copy-right">
          <p>© OSource Empire · Copyright 2021 · All rights reserved</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
